import { get } from "@/services/axiosUitils";
import { PaginatedResponse } from "@/utils/types/tenantPermissions";
import { ApiResponse, PranRegistrationResponse } from "@/utils/types/NpsUser";

const base = "/nps/admin/registrations/";

class NpsUserService {
  listNpsUsers = async (
    page = 1,
    pageSize = 20
  ): Promise<PaginatedResponse<ApiResponse>> => {
    return await get<PaginatedResponse<ApiResponse>>(base, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getNpsUserById = async (ackId: string): Promise<PranRegistrationResponse> => {
    return await get<PranRegistrationResponse>(`${base}${ackId}/`);
  };
}

const instance = new NpsUserService();
export default instance;
